export default {
  loading: false,
  record: {},
  orderCountLoading: false,
  orderCountRecord: {},

  // Analytics related state
  analyticsCounts: [],
  analyticsLoading: false,
  analyticsListRecords: [],
  analyticsListTotal: 0,
  analyticsListFilteredCount: 0,
  analyticsListLoading: false
}
